<template>
  <div id="SectionWebinar">
    <UIContainer class="SectionWebinar__container">
      <div class="SectionWebinar__content">
        <div class="SectionWebinar__left">
          <div class="SectionWebinar__date-tag">
            <span class="SectionWebinar__date-label">When?</span>
            <div class="SectionWebinar__date-value">
              October 31st
              <UIIcon class="SectionWebinar__date-icon" name="arrowRight" />
            </div>
          </div>

          <h1 class="SectionWebinar__title">
            Sustainability round up

            <span class="SectionWebinar__description">
              Vol.5: An exclusive conversation for sustainability professionals
            </span>
          </h1>
        </div>

        <UIForm class="SectionWebinar__form">
          <h1 class="SectionWebinar__form-title">
            Register to the upcoming webinar
          </h1>
          <UIInputText name="fullName" label="Full Name" isRequired />
          <UIInputText name="companyName" label="Company Name" isRequired />
          <UIInputText
            name="email"
            label="Work email"
            isRequired
            type="email"
          />
          <UIInputText name="phoneNumber" label="Phone Number" isRequired />
          <UIInputCheckbox
            name="agreeToPrivacy"
            isRequired
            label="By submitting, you agree to our Privacy Policy."
          />
          <UIButton type="submit" isFull>Submit</UIButton>
        </UIForm>
      </div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'
import UIForm from '@/views/components/ui/forms/UIForm.vue'
import UIInputText from '@/views/components/ui/inputs/UIInputText.vue'
import UIInputCheckbox from '@/views/components/ui/inputs/UIInputCheckbox.vue'
import UIButton from '@/views/components/ui/buttons/UIButton.vue'

const formData = ref({
  fullName: '',
  companyName: '',
  workEmail: '',
  phoneNumber: '',
  agreeToPrivacy: false,
})

const handleSubmit = () => {
  // Handle form submission
  console.log('Form submitted:', formData.value)
}
</script>

<style lang="scss" scoped>
#SectionWebinar {
  .SectionWebinar__container {
    padding-top: 2rem;

    @include md {
      padding-top: 4rem;
    }
  }

  .SectionWebinar__left {
    max-width: 42rem;
    width: 100%;
  }

  .SectionWebinar__content {
    display: flex;
    gap: 2rem;

    @include md {
      gap: 4rem;
    }
  }

  .SectionWebinar__date-tag {
    display: inline-flex;
    border: 1px solid $color-ui-brand-200;
    border-radius: 50px;
    background: $color-ui-brand-50;
    margin-bottom: 1rem;
    overflow: hidden;
    padding: 0.25rem;
  }

  .SectionWebinar__date-label {
    @include font-size-14px();
    font-weight: 500;
    background: $color-white;
    color: $color-ui-brand-700;
    border: 1px solid $color-ui-brand-200;
    border-radius: 2rem;
    padding: 0.125rem 0.625rem;
    height: fit-content;
    margin-right: 0.5rem;
  }

  .SectionWebinar__date-value {
    @include font-size-14px();
    color: $color-ui-brand-700;
    font-weight: 500;
    padding: 2px 2px 2px 0;
    display: flex;
    gap: 0.25rem;
    align-items: center;
  }

  .SectionWebinar__date-icon {
    --size: 1rem;
    --color: #{$color-ui-brand-500};
  }

  .SectionWebinar__title {
    @include font-size-36px();
    font-weight: 600;
    color: $color-ui-gray-cool-900;

    @include md {
      @include font-size-60px();
    }
  }

  .SectionWebinar__description {
    @include font-size-36px();
    font-weight: 600;
    background: linear-gradient(45deg, #023025 0%, #04785e 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;

    @include md {
      @include font-size-60px();
    }
  }

  .SectionWebinar__form {
    height: 656px;
    width: 100%;
    max-width: 544px;
    background: $color-white;
    box-shadow: 0px 3px 3px -1.5px #0010350a;
    box-shadow: 0px 8px 8px -4px #00103508;
    box-shadow: 0px 4px 24px -4px #00103514;
    border-radius: 20px;
    padding: 1.25rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.5rem;

    @include md {
      padding: 2rem;
    }
  }

  .SectionWebinar__form-title {
    @include font-size-36px();
    color: $color-ui-gray-cool-900;
    font-weight: 600;
  }
}
</style>
